<app-page-header
  [title]="'Administrador de Áreas y Cargos'"
  [subtitle]="
    'Podrás gestionar las áreas y cargos que se asignen a un Empleado'
  "
></app-page-header>

<app-page-acciones
  [buttonText]="'Nueva área'"
  [buttonIcon]="'pi pi-plus'"
  [buttonColor]="'#E45F23'"
  (buttonClick)="onNewRegister()"
  [hasButtonSecond]="false"
  [hasCombo]="false"
  [hasYearOptions]="false"
  [searchQuery]="searchTerm"
  (searchQueryChange)="onSearch($event)"
></app-page-acciones>

<app-list-card
  [items]="jobAreaData"
  titleField="areaName"
  sublistField="jobPositionDTO"
  subitemField="jobPositionName"
  [isLoading]="isLoading"
  (addClicked)="onNewRegisterJobPosition($event)"
  (editClicked)="onEditArea($event)"
  (subitemEditClicked)="onEditJobPosition($event)"
></app-list-card>

<div class="area-register-modal">
  <app-area-register-modal
    [(visible)]="showRegisterModal"
    (visibleChange)="onDialogClose()"
    (registerComplete)="onRegisterComplete()"
  >
  </app-area-register-modal>
</div>

<div class="area-edit-modal">
  <app-area-edit-modal
    [(visible)]="showEditModal"
    [areaId]="selectedAreaId"
    (visibleChange)="onDialogClose()"
    (registerComplete)="onEditComplete()"
  >
  </app-area-edit-modal>
</div>

<div class="jobposition-register-modal">
  <app-jobposition-register-modal
    [(visible)]="showRegisterJobPositionModal"
    [areaId]="selectedAreaId"
    (visibleChange)="onDialogJobPositionClose()"
    (registerJobPositionComplete)="onRegisterJobPositionComplete()"
  >
  </app-jobposition-register-modal>
</div>

<div class="jobposition-edit-modal">
  <app-jobposition-edit-modal
    [(visible)]="showEditJobPositionModal"
    [areaId]="selectedAreaId"
    [jobPositionId]="selectedJobPositionId"
    (visibleChange)="onDialogJobPositionClose()"
    (editJobPositionComplete)="onEditJobPositionComplete()"
  >
  </app-jobposition-edit-modal>
</div>
